import { render, staticRenderFns } from "./KAPAI.vue?vue&type=template&id=4d8b26c2&scoped=true"
import script from "./KAPAI.vue?vue&type=script&lang=js"
export * from "./KAPAI.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8b26c2",
  null
  
)

export default component.exports